import SharePreviewContent from 'components/ShareDocument/SharePreviewContent';
import { extensionFromContentType } from 'components/UploadHub/fileTypeBadges';
import SharePreviewToolbar from './SharePreviewContent/SharePreviewToolbar';
import { PdfPreviewProvider, PdfPageControls, PdfZoomControls } from './SharePreviewContent/PdfPreviewProvider';

export const withExtension = ({ fileName, contentType }: { fileName?: string; contentType?: string }) => {
  if (!fileName || /\.[^./]+$/.test(fileName)) return fileName;
  const ext = extensionFromContentType(contentType);
  return ext ? `${fileName}.${ext}` : fileName;
};

export interface SharedDocumentData {
  documentUrl?: string;
  fileName?: string;
  contentType?: string;
  backgroundColor?: string;
  barBackgroundColor?: string;
  organisationLogo?: string;
}

const SharedDocumentPreview = ({ document: sharedDocument }: { document: SharedDocumentData }) => {
  const fileNameWithExtension = withExtension({
    fileName: sharedDocument.fileName,
    contentType: sharedDocument.contentType,
  });
  const barBackgroundColor = sharedDocument.barBackgroundColor ?? '#00122b';
  const url = sharedDocument?.documentUrl ?? '';

  return (
    <PdfPreviewProvider url={url}>
      <div style={{ backgroundColor: sharedDocument.backgroundColor, minHeight: '100vh' }}>
        <SharePreviewToolbar
          url={url}
          filename={sharedDocument.fileName}
          logo={sharedDocument.organisationLogo}
          barBackgroundColor={barBackgroundColor}
          left={<PdfZoomControls />}
          right={<PdfPageControls />}
        />
        <div className='share-document-preview-container'>
          <div
            className='share-document-page main-content-wrapper px-3 px-lg-5 pt-5 mx-auto'
            style={{ maxWidth: '920px' }}
          >
            <div className='share-document-preview  mx-auto'>
              <SharePreviewContent
                url={url}
                filename={fileNameWithExtension}
                logo={sharedDocument.organisationLogo}
                barBackgroundColor={barBackgroundColor}
              />
            </div>
          </div>
        </div>
      </div>
    </PdfPreviewProvider>
  );
};

export default SharedDocumentPreview;
